import { Component, OnInit, ViewEncapsulation, HostListener } from '@angular/core';
import { MessageService } from "./../services/message.service";
import { CacheKey } from '../../shared/constants/cachekey.constants';
import { CacheService } from "../../shared/services/cache.service";
import { UserInfo } from '../../shared/interface/user-info.interface';
import { UserPrivilege } from '../../shared/interface/user-privilege.interface';
import { DataShareService } from "../services/data.service";


@Component({
  selector: 'app-layout',
  templateUrl: "../templates/template1/views//app-layout.component.html",
  styleUrls: ["../templates/template1/themes/default/CSS/app-layout.less"],
  encapsulation:  ViewEncapsulation.None
})
export class AppLayoutComponent implements OnInit {
  mainbodyHeight: number;
  totalHeight: number;
  bodyHeight: number;
  footerHeight: number = 42;
  bodyWidth: number;
  marginLeft: any;
  rightContentWidth: number;
  permissionsOnLoad: boolean = false;
  constructor(private _messageService: MessageService, private _cacheService: CacheService, private _dataShareService: DataShareService) {
  }
  ngOnInit() {
    //  this.alterheight();

    this.totalHeight = window.innerHeight;
   
    this.mainbodyHeight = this.totalHeight - window.document.getElementById("header").offsetHeight - this.footerHeight;
    this.toggleSideNav();
    let userInfo: UserInfo = this._cacheService.get(CacheKey.UserInfo);
    if (userInfo && userInfo.privileges) {
      this.permissionsOnLoad = true;
    }
    else {
      this._messageService.getUserPermissionFlag().subscribe(response => {
        if (response != null && response) {
          this.permissionsOnLoad = true;
        }
      });
    }
  }

  sideMenuEmit(res: boolean) {
   
    this.toggleSideNav();
  }

  alterheight() {
    this.totalHeight = window.innerHeight;
    this.mainbodyHeight = this.totalHeight - window.document.getElementById("header").offsetHeight - this.footerHeight;

    // this.bodyWidth = window.innerWidth - window.document.getElementById("sideNav").offsetWidth - 10;

  }

  @HostListener('window:resize') onResize() {
    // guard against resize before view is rendered
    this.alterheight();
  }

  Resize(event: any) {
    this.alterheight();
  }
  toggleSideNav() {
 
    let windowWidth = window.innerWidth;
    let contentWidth = window.document.getElementById("admin-content").offsetWidth;
    let halfMenu = window.document.getElementById("haff-menu");

    if (halfMenu) {
      if (!halfMenu.classList.contains('showHalfMenu')) {
        this.rightContentWidth = windowWidth - 70;
        this.marginLeft = 50;
      }
      else {
        this.rightContentWidth = windowWidth - 272;
        this.marginLeft = 253;
      }      
    }
    else {
      this.rightContentWidth = windowWidth - 272;
      this.marginLeft = 253;
    }
    this._dataShareService.changeCustomerServiceMessage(this.rightContentWidth + "-csRightMenuWidth");
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/app-layout.component.ts